<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <span>
                <v-btn plain icon v-bind="attrs" v-on="on" v-on:click="actionClick()">
                    <v-icon medium>mdi-download</v-icon>
                </v-btn>
            </span>
        </template>
        <span>Download</span>
    </v-tooltip>      
</template>

<script>
    export default {
        methods: {
            actionClick(){
                this.$emit('actionClick', 'download');
            },
        }
    }
</script>